export const API_TYPE = {
  DATASETS: 'datasets',
  ENTRIES: 'entries',
  INSTRUMENTS: 'instruments',
  SAMPLES: 'samples',
  USERS: 'users'
};
export default {
  '/users': {
    type: API_TYPE.USERS
  },
  '/users/{id}': {
    type: API_TYPE.USERS
  },
  '/users/self': {
    type: API_TYPE.USERS
  },
  '/datasets': {
    type: API_TYPE.DATASETS
  },
  '/datasets/{id}': {
    type: API_TYPE.DATASETS
  },
  '/datasets/{id}/download': {
    type: API_TYPE.DATASETS
  },
  '/datasets/{id}/releases': {
    type: API_TYPE.DATASETS
  },
  '/datasets/{id}/relationships/sharingGroups': {
    type: API_TYPE.DATASETS
  },
  '/releases': {
    type: API_TYPE.DATASETS
  },
  '/releases/{id}': {
    type: API_TYPE.DATASETS
  },
  '/catalogs/{id}': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/data': {
    type: API_TYPE.DATASETS
  },
  '/data/{id}': {
    type: API_TYPE.DATASETS
  },
  '/data/{id}/files': {
    type: API_TYPE.DATASETS
  },
  '/data/{id}/virusScanFiles': {
    type: API_TYPE.DATASETS
  },
  '/data/{id}/relationships/files': {
    type: API_TYPE.DATASETS
  },
  '/datacsv': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/restructureRequests': {
    type: API_TYPE.DATASETS
  },
  '/restructureRequestsAsCsv': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/restructureRequests/{id}': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/datasetTemplates': {
    type: API_TYPE.DATASETS
  },
  '/datasetTemplates/{id}': {
    type: API_TYPE.DATASETS
  },
  '/catalogSchemas/{id}': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/invoiceSchemas/{id}': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/metadataDefs/{id}': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/invoices/{id}': {
    type: API_TYPE.DATASETS
  },
  '/groups': {
    type: API_TYPE.DATASETS
  },
  '/groups/{id}': {
    type: API_TYPE.DATASETS
  },
  '/groups/{id}/members': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/licenses': {
    type: API_TYPE.DATASETS
  },
  '/files/{id}': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/searchResults': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/metadata': {
    type: API_TYPE.DATASETS,
    isRest: true
  },
  '/uploads': {
    type: API_TYPE.ENTRIES
  },
  '/uploads/{id}': {
    type: API_TYPE.ENTRIES
  },
  '/entries': {
    type: API_TYPE.ENTRIES
  },
  '/entries/{id}': {
    type: API_TYPE.ENTRIES
  },
  '/entries/{id}/virusScanFiles': {
    type: API_TYPE.ENTRIES
  },
  '/samples': {
    type: API_TYPE.SAMPLES
  },
  '/samples/{id}': {
    type: API_TYPE.SAMPLES
  },
  '/samples/{id}/relationships/sharingGroups': {
    type: API_TYPE.SAMPLES
  },
  '/sampleTerms': {
    type: API_TYPE.SAMPLES
  },
  '/sampleClasses': {
    type: API_TYPE.SAMPLES
  },
  '/instruments': {
    type: API_TYPE.INSTRUMENTS
  },
  '/instruments/{id}': {
    type: API_TYPE.INSTRUMENTS
  },
  '/organizations': {
    type: API_TYPE.INSTRUMENTS
  },
  '/instrumentGroups': {
    type: API_TYPE.INSTRUMENTS
  },
  '/typeTerms': {
    type: API_TYPE.INSTRUMENTS
  },
  '/programs': {
    type: API_TYPE.INSTRUMENTS
  }
};
